import React from 'react';
import { Button } from '@/components/ui/button';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const CallToAction: React.FC = () => {
  const appSignUpUrl = import.meta.env.VITE_APP_URL
    ? `${import.meta.env.VITE_APP_URL}/auth?mode=signup`
    : '/auth?mode=signup';

  return (
    <Card className="relative my-12 overflow-hidden border-slate-200 bg-white shadow-sm">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-orange-100 rounded-full blur-3xl opacity-50 pointer-events-none"></div>
      
      <CardContent className="relative z-10 flex flex-col items-center justify-between gap-8 p-8 md:flex-row md:p-10">
        <div className="flex items-start gap-5">
          <div className="flex-shrink-0 rounded-2xl border border-slate-200 bg-white p-4 text-orange-500 shadow-sm">
            <Sparkles className="h-8 w-8" />
          </div>
          <div className="space-y-2">
            <h3 className="text-2xl font-sans font-bold text-slate-900">Ready to launch financing checkout?</h3>
            <p className="max-w-lg text-base leading-relaxed text-slate-600">
              Start with one quote, share by link or QR, and help buyers choose monthly options that fit their budget.
            </p>
          </div>
        </div>
        <Button asChild size="lg" className="h-14 w-full flex-shrink-0 rounded-full bg-slate-900 px-8 text-lg text-white shadow-lg transition-all hover:-translate-y-0.5 hover:bg-slate-800 hover:shadow-xl md:w-auto">
          <a href={appSignUpUrl}>
            Start Selling <ArrowRight className="ml-2 h-5 w-5" />
          </a>
        </Button>
      </CardContent>
    </Card>
  );
};

export default CallToAction;
